/**
 * Created by Pawan on 06/03/2017.
 */

import { GetCredentialsVabQuery, ServerRepoId } from '../autogenerated/ZoomBridge';
import Authenticator from '../protocol/Authenticator';

export default class GetCredentialsQuery {
  constructor(username, cookie) {
    this.username = username;
    this.cookie = cookie;
  }

  run() {
    return new Promise((onSuccess, onFailure) => {
      Authenticator.AUTH_DATA.username = this.username;
      Authenticator.AUTH_DATA.password = null;
      Authenticator.AUTH_DATA.cookie = this.cookie;

      const getcredentialQuery = new GetCredentialsVabQuery();
      getcredentialQuery.message = new ServerRepoId();
      getcredentialQuery.message.setEnableDecluttering(true);
      getcredentialQuery.run().then(
        (resp) => {
          onSuccess(resp);
        },
        (failedResp) => {
          onFailure(failedResp);
        }
      );
    });
  }
}
